import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { Flex, Box } from "rebass/styled-components"

import Layout from "../components/Layout"
import Categories from "../components/Categories"
import TagsBlock from "../components/TagsBlock"
import BlogItem from "../components/BlogItem"
import Seo from "../components/Seo"

const Heading = styled.h1`
  color: ${({ theme }) => theme.colors.orange};
  font-size: 1.5rem;
  margin-bottom: 1rem;
`

const CategoryPage = ({ data, path }) => (
  <Layout>
    <Seo
      title="Категории блога компании Глэд | Glead"
      description="Блог компании по производству мебели и торгового оборудования на заказ в Москве"
      keywords="блог по производству мебели и торгового оборудованияя на заказ в Москве"
      path={path}
    />
    <Heading>Блог о Glead</Heading>
    <Flex flexWrap="wrap">
      <Flex width={[1, 0.65, 0.75]} flexWrap="wrap" pr={[0, 0, 2]}>
        {data.allNodeBlogPost.edges.map(({ node }) => (
          <BlogItem key={node.id} post={node} />
        ))}
      </Flex>
      <Box width={[1, 0.35, 0.25]}>
        <Categories />
        <TagsBlock />
      </Box>
    </Flex>
    {/* <Pagination
      numberOfPages={numberOfPages}
      currentPage={currentPage}
    /> */}
  </Layout>
)

export default CategoryPage

export const pageQuery = graphql`
  query($id: String!) {
    allNodeBlogPost(
      filter: {
        relationships: {
          field_blog_category: { elemMatch: { id: { eq: $id } } }
        }
      }
    ) {
      edges {
        node {
          id
          title
          created
          body {
            value
          }
          path {
            alias
          }
          relationships {
            field_media {
              relationships {
                field_media_image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
              }
            }
            field_image {
              uri {
                url
              }
            }
            field_tags {
              name
              path {
                alias
              }
            }
          }
        }
      }
    }
  }
`
